<div class="map__container" #mapContainer>
	@if (showPanControls) {
		<div class="map__pan-controls">
			@for (btn of panControls; track $index) {
				<button
					class="map__pan-control"
					[attr.style]="'--pan-control-area: ' + btn"
					type="button"
					(click)="panMap(btn, $event)"
					[attr.aria-label]="'map.move_' + btn | translate"
				>
					<icon [glyph]="'chevron-' + btn" />
				</button>
			}
		</div>
	}
	@if (showZoomButtons) {
		<div class="map__zoom-controls">
			<button
				class="map__zoom-btn"
				type="button"
				(click)="setZoom(zoom + 0.5)"
				aria-label="Zoom in"
			>
				<icon glyph="plus" size="xmedium" />
			</button>
			<button
				class="map__zoom-btn"
				type="button"
				(click)="setZoom(zoom - 0.5)"
				aria-label="Zoom out"
			>
				<icon glyph="minus" size="xmedium" />
			</button>
		</div>
	}
	@if (showGeolocationButton) {
		<button
			class="map__geolocation-btn"
			type="button"
			(click)="onGeolocationButtonClick()"
			[disabled]="geolocationLoading"
			[attr.aria-label]="'map.geolocation_button' | translate"
		>
			<icon glyph="geolocation" size="xmedium" noFill="true"/>
		</button>
	}
	@if (geolocationOverlayVisible) {
		<div class="map__geolocation-overlay" role="dialog" aria-modal="true">
			<p
				class="map__geolocation-text"
				[innerHTML]="'map.geolocation_overlay_text' | translate"
			></p>
			<div class="map__geolocation-actions">
				<button htm-button type="button" (click)="confirmGeolocation()">
					{{ 'map.geolocation_personalise' | translate }}
				</button>
				<button
					htm-button
					theme="outline-dark"
					type="button"
					(click)="dismissGeolocation()"
				>
					{{ 'map.geolocation_skip' | translate }}
				</button>
			</div>
		</div>
	}
	<ng-content></ng-content>
</div>
